/* eslint-disable no-param-reassign */
/* eslint no-unused-vars: ["error", {"args": "none"}] */
/* eslint max-len: ["error", { "code": 200, "tabWidth": 4 }] */
/* eslint camelcase: [2, {
	"allow": ["i_chronicle_id", "module_chronic_id", "chronic_id"]
}] */
/* eslint no-underscore-dangle: [2, {
	"allow": ["_chronic_id"]
}] */
import axios from 'axios';
import _forEach from 'lodash/forEach';
import _has from 'lodash/has';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _findKey from 'lodash/findKey';
import _set from 'lodash/set';
import _isArray from 'lodash/isArray';
import _isString from 'lodash/isString';
import oauth from 'webmd-oauth/src/index.es6';
// eslint-disable-next-line
import { $capId } from '@/app';
import _includes from 'lodash/includes';
import _extend from 'lodash/extend';
import _get from 'lodash/get';
import { defineStore } from 'pinia';
import regService from 'webmd-reg-service/index.es6';
import utils from '../helpers/utils.es6';
import { useMainStore } from './root.es6';
import { useQuizStore } from './quiz.es6';

/**
 * We don't want any data from these modules
 */
// eslint-disable-next-line max-len
const blackListedModules = ['091e9c5e8136f447', '091e9c5e8137e40e', '091e9c5e81e8d9e8', '091e9c5e8141403f', '091e9c5e814fc6c6', '091e9c5e817e2be7', '091e9c5e81374172', '091e9c5e813ece18', '091e9c5e81f6692a'];
const oauthHeaders = oauth.generate();

/**
 * removes null, empty, undefined kv pairs
 * @param object
 */
function clean(object) {
	Object.entries(object).forEach(([k, v]) => {
		if (v && typeof v === 'object') {
			clean(v);
		}
		// eslint-disable-next-line no-mixed-operators
		if (v && typeof v === 'object' && !Object.keys(v).length && k !== 'br' || v === null || v === undefined) {
			if (Array.isArray(object)) {
				object.splice(k, 1);
			} else {
				// eslint-disable-next-line no-param-reassign
				delete object[k];
			}
		}
	});
	return object;
}

/**
 * Filter out the article module of the CAP based on "article" label applied in PB
 * Returns the module data with article key added and original key removed
 * @param moduleData
 * @return {boolean|*}
 */
function getArticle(moduleData) {
	const modules = Object.keys(moduleData);
	const articleModule = modules.filter((m) => {
		const mod = moduleData[m];

		return _has(mod, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val')
			&& mod.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val === 'article';
	});

	if (articleModule.length === 1) {
		moduleData.articleModule = moduleData[articleModule[0]];
		delete moduleData[articleModule[0]];
		return moduleData;
	}
	return moduleData;
}

function parseStyleConfig(moduleData) {
	/*
	 * Non sitefronts pages also has module settings, so adding a null check
	 * around module_data
	 */
	if (!moduleData || !moduleData.module_data) {
		return false;
	}

	const config = {
		moduleId: '',
		images: {},
		links: {},
		variables: {},
	};

	if (moduleData.module_data && moduleData.module_data.body_images
		&& moduleData.module_data.body_images.body_image) {
		config.images = _map(moduleData.module_data.body_images.body_image, (b, i) => ({
			// eslint-disable-next-line no-nested-ternary
			type: i === 0 ? 'logo' : i === 1 ? 'guide_mod_bg' : 'guide_toc_bg',
			alt: b.source.alt,
			path: b.source.path,
			title: b.override_text,
			link: b.image_link ? b.image_link.link_friendly_url : null,
		}));
	}

	if (moduleData.module_data && moduleData.module_data.descriptions
		&& moduleData.module_data.descriptions.description) {
		config.links = _map(moduleData.module_data.descriptions.description, (d) => ({
			type: d.description_text.includes('.js') ? 'js' : 'css',
			path: d.description_text,
			ext: !d.description_text.includes('/webmd/'),
		}));
	}

	if (moduleData.module_data && moduleData.module_data.links
		&& moduleData.module_data.links.link) {
		_forEach(moduleData.module_data.links.link, (l) => {
			if (l.link_text !== '') {
				config.variables[l.link_text] = l.action_text;
			}
		});
	}

	config.moduleId = moduleData.module_settings.chronic_id;

	return config;
}

function parseNavConfig(moduleData) {
	/*
	 * Non sitefronts pages also has module settings, so adding a null check
	 * around module_data
	 */
	if (!moduleData || !moduleData.module_data) {
		return false;
	}

	const nav = {
		moduleId: '',
		items: [],
	};
	if (moduleData && moduleData.module_data && moduleData.module_data.groups && moduleData.module_data.groups.group) {
		nav.items = _map(moduleData.module_data.groups.group, (b) => ({
			name: b.group_name.split('[')[0],
			channelId: b.group_name.includes('[') ? b.group_name.split('[')[1].split(']')[0] : null,
			link: b.group_link_url,
		})).filter((i) => i.name !== '');
	}

	nav.moduleId = moduleData.module_settings.chronic_id;

	return nav;
}

function parseMode(moduleData) {
	/*
	 * Non sitefronts pages also has module settings, so adding a null check
	 * around module_data
	 */
	if (!moduleData || !moduleData.module_data) {
		return null;
	}

	// Adding blank override
	if (_has(moduleData, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val')) {
		if (moduleData.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val === 'no_desktop') {
			return '';
		}
	}

	if (moduleData && moduleData.module_settings && moduleData.module_settings.title.toLowerCase().includes('oncology')) {
		return 'oncology';
	}

	return 'sitefronts';
}

/**
 *
 * @param data - the API response data
 * @param host - host name to make an API call
 * @param route - for query parameters
 * @returns {Promise<*>} updated API resonse data with newly added RSS module data
 */

async function getRssModuleData(data, host, route) {
	const rssMod = {};

	_forEach(data.webmd_module, (modChronId, index) => {
		if (_has(modChronId, 'module_settings.Class')
			&& modChronId.module_settings.Class === 'RSS'
			&& modChronId.module_data && modChronId.module_data.rss_url) {
			let rssDataUrl;

			// Check for existance of host information in the url
			if (modChronId.module_data.rss_url.includes('http') && !modChronId.module_data.rss_url.includes('search/2/api/')
				&& !modChronId.module_data.rss_url.includes('.nodeapihost.com')) {
				rssDataUrl = `${modChronId.module_data.rss_url}`;
			} else if (modChronId.module_data.rss_url.includes('.nodeapihost.com')) {
				rssDataUrl = utils.getNodeApiEnvironment(host, modChronId.module_data.rss_url);
			} else {
				rssDataUrl = `${utils.getEnvironment(host).servicedomain}${modChronId.module_data.rss_url}`;
			}

			// updating query parameter filter and pagenumber
			if (_includes(rssDataUrl, '_filter_') || _includes(rssDataUrl, '_pagenum_')) {
				rssDataUrl = utils.getUpdatedRssUrl(rssDataUrl, route, modChronId.module_data.show_link_count);
			}
			if (!rssMod[index]) {
				rssMod[index] = {};
			}
			if (rssDataUrl) {
				rssMod[index] = rssDataUrl;
			}
		}
	});

	const promises = Object.entries(rssMod).map((rssArr) => axios.get(rssArr[1], {
		headers: (_includes(rssArr[1], 'wbmdstatic')) ? {} : { ...oauthHeaders, 'user-agent': 'webmd-cms-store' },
		rssChronId: rssArr[0],
		timeout: 3000,
	})
		.then((response) => response)
		.catch((err) => {
			// eslint-disable-next-line no-console
			console.log('CMS Store RSS Fetch Error', err.config);
			return false;
		}));

	const collectAllPromises = await Promise.all(promises);

	_forEach(collectAllPromises, (prom) => {
		if (prom.config && prom.config.rssChronId) {
			// eslint-disable-next-line camelcase
			data.webmd_module[prom.config.rssChronId].rss_data = (prom.data && prom.data.results) ? prom.data.results : prom.data;
		}
	});
	return data;
}

/**
 * This function will return the data for both ArticleSnippet module / ArticleModlue module on page builder
 * Most of the times, ArticleSnippet module type is being used, so we named this function as getArticleSnippetData
 * But it will also fetch the data from ArticleModule module type which is defined here - https://www.webmd.com/baby/interactive-pregnancy-tool-fetal-development
 * @param data - the API response data
 * @param host - host name to make an API call
 * @param route - for query parameters
 * @returns {Promise<*>} updated API resonse data with newly added (ArticleSnippet / ArticleModule) data
 */

async function getArticleSnippetData(data, host, route) {
	const articleData = {};
	_forEach(data.webmd_module, (modChronId, index) => {
		if (_has(modChronId, 'module_settings.Class') && modChronId.module_data) {
			let articleId;
			if (modChronId.module_settings.Class === 'ArticleSnippet' && modChronId.module_data.articleTitle
				&& modChronId.module_data.articleTitle !== '') {
				articleId = `${modChronId.module_data.articleTitle}`;
			} else if (modChronId.module_settings.Class === 'ArticleModule' && modChronId.module_data.articleTitle
				&& modChronId.module_data.articleTitle.chronic_id && modChronId.module_data.articleTitle.chronic_id !== '') {
				articleId = `${modChronId.module_data.articleTitle.chronic_id}`;
			}

			// only create empty objects modules which has articleId
			if (!articleData[index] && articleId) {
				articleData[index] = {};
			}
			if (articleId) {
				articleData[index] = articleId;
			}
		}
	});
	const promises = Object.entries(articleData).map((artArr) => axios.get(`${utils.getEnvironment(host).servicedomain}/search/2/api/cms_repositorysvc_artdata?id=${artArr[1]}`, {
		headers: { ...oauthHeaders, 'user-agent': 'webmd-cms-store' },
		articleChronId: artArr[0],
		timeout: 3000,
	})
		.then((response) => response)
		.catch((err) => {
			// eslint-disable-next-line no-console
			console.log('CMS Store ArticleSnippet Fetch Error', err.config);
			return false;
		}));
	const collectAllPromises = await Promise.all(promises);
	_forEach(collectAllPromises, (prom) => {
		// eslint-disable-next-line camelcase
		const resData = {
			// eslint-disable-next-line camelcase
			content_section: {},
			// eslint-disable-next-line camelcase
			metadata_section: {},
		};
		let resolvedData;
		if (prom.data && prom.data.data) {
			if (prom.data.data.wxml_content_jsoncdata[0]) {
				resolvedData = JSON.parse(prom.data.data.wxml_content_jsoncdata[0]);
			}
			if (prom.data.data.bio_obj_urls_mvs[0]) {
				// eslint-disable-next-line camelcase
				resData.bio_obj_urls_mvs = JSON.parse(prom.data.data.bio_obj_urls_mvs[0]);
			}
		} else {
			// eslint-disable-next-line no-console
			console.log('The data for wxml_content_jsoncdata[0] doesnot exists ...', prom.data);
		}
		if (resolvedData && resolvedData.wbmd_asset) {
			if (resolvedData.wbmd_asset.content_section) {
				// eslint-disable-next-line camelcase
				resData.content_section = resolvedData.wbmd_asset.content_section;
			}
			if (resolvedData.wbmd_asset.metadata_section) {
				// eslint-disable-next-line camelcase
				resData.metadata_section = resolvedData.wbmd_asset.metadata_section;
			}
		}
		// eslint-disable-next-line camelcase
		data.webmd_module[prom.config.articleChronId].articleSnippet_data = resData;
	});
	return data;
}

/**
 * Filter out the interactive articles pages based on "interactive_article" label applied in PB on ia-header module
 * Returns true or false based on the label
 * @param moduleData
 * @return {boolean|*}
 */
function setInteractiveFlag(moduleData) {
	const modules = Object.keys(moduleData);

	const iaHeaderModule = modules.filter((chronId) => {
		const module = moduleData[chronId];
		return _has(module, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val')
			&& module.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val === 'interactive_article';
	});
	if (iaHeaderModule.length > 0) {
		return true;
	}

	return false;
}

/**
 * Fetching Friendly URL for an assets
 *
 * We can relate asset to another Assets by using Aspen Tool
 * Like relation is establishing for english asset to any other language asset
 * Reltation Asset Ids were available on pagedata - assetrelations parameter as array of objects
 * This objects are having chornic ids only by using chronic ids fetching friendly ulrs and updating again
 *
 * @param host
 * @param pageDataObj
 * @param assetInstanace
 * @returns
 */
// eslint-disable-next-line consistent-return
async function setAssetRelationsUrls(host, pageDataObj, assetInstanace) {
	if (pageDataObj && pageDataObj.assetrelations && pageDataObj.assetrelations.length) {
		const pageAssetRelations = pageDataObj.assetrelations;
		const relatedAspenIds = _map(pageAssetRelations, (relObj) => relObj.related_asset_id);
		const relatedDctmIds = _map(pageAssetRelations, (relObj) => {
			if (!_includes(relObj.related_asset_id, 'DCTM_')) {
				return `DCTM_${relObj.related_asset_id}`;
			}
			return relObj.related_asset_id;
		});
		let relatedAssetUrls = pageAssetRelations;
		if (relatedDctmIds.length) {
			return axios.get(`${utils.getEnvironment(host).servicedomain}/search/2/api/blogs_asset_info?q=id:(${relatedDctmIds.join(' ')}) OR aspenid_s:(${relatedAspenIds.join(' ')})`, {
				headers: { ...oauthHeaders },
			})
				.then((assetInfoResponse) => {
					if (assetInfoResponse && assetInfoResponse.data && assetInfoResponse.data.code === 100) {
						const relatedAssetResponse = _get(assetInfoResponse, 'data.data', []);
						relatedAssetUrls = _map(pageAssetRelations, (assetobj) => {
							const friendlyUrlObj = _find(relatedAssetResponse, (res) => (assetobj.related_asset_id === res.id.replace('DCTM_', '') || assetobj.related_asset_id === res.aspenId));
							// eslint-disable-next-line camelcase
							assetobj.related_friendly_url = (friendlyUrlObj) ? friendlyUrlObj.url : '';
							return assetobj;
						});
					} else {
						relatedAssetUrls = _map(pageAssetRelations, (assetobj) => {
							// eslint-disable-next-line camelcase
							assetobj.related_friendly_url = '';
						});
					}
					assetInstanace.setPageDataByKey('assetrelations', relatedAssetUrls);
					return true;
				})
				.catch((err) => {
					// eslint-disable-next-line no-console
					console.log('CMS Store Related asset urls Fetch Error', err);
					relatedAssetUrls = _map(pageAssetRelations, (assetobj) => {
						// eslint-disable-next-line camelcase
						assetobj.related_friendly_url = '';
					});
					assetInstanace.setPageDataByKey('assetrelations', relatedAssetUrls);
				});
		}
		const asestUrlsData = _map(pageAssetRelations, (assetobj) => {
			// eslint-disable-next-line camelcase
			assetobj.related_friendly_url = '';
		});
		assetInstanace.setPageDataByKey('assetrelations', asestUrlsData);
	} else {
		return [];
	}
}

/**
 * Fetching newsletter mapping for the current page based on channel ID
 *
 * @param pageData
 * @param host
 * @returns {Promise<*|boolean>}
 */
async function getNewsletterMapping(pageData, host) {
	const channelId = pageData?.omniture?.center_id || '0';

	if (channelId) {
		try {
			const result = await regService.getNewsletterByChannel(channelId, host);

			if (result) {
				return result;
			}

			return false;
		} catch {
			return false;
		}
	}

	return false;
}

/**
 * @type {{getPageAndMetaData: actions.getPageAndMetaData}}
 * should contain only 1 API call to SOLR.
 */
const actions = {
	/**
	 * This is called by asyncData() of cms-router
	 */
	getPageAndMetaData({
		route, host, env, staticPublicPath, res,
	}) {
		const rootState = useMainStore();
		const staticData = utils.getStaticData();
		const endpoint = staticData.endpoints.cms_articles;
		let capId = route.params.capid || false;
		let moduleApiData;
		let moduleRssData;

		const params = {
			id: route.params.articleid,
		};

		if (!capId && $capId) {
			capId = $capId;
		}

		if (capId === '091e9c5e8167c6d8') {
			res.statusCode = 404;
		} else if (capId === '091e9c5e8167c6d9') {
			res.statusCode = 500;
		}

		const apiUrl = `${utils.getEnvironment(host).servicedomain}/search/2/api/${endpoint}`;

		if (route.params.channelid && capId) {
			params.channelid = route.params.channelid;
			params.capid = capId;
			params.count = 2000;
		}

		return axios.get(apiUrl, {
			params,
			headers: oauthHeaders,
		})
			.then(async (response) => {
				if (response.status === 200 && _has(response, 'data.data[0]')) {
					if (_has(response, 'data.data[0].webmd_module')) {
						moduleRssData = await getRssModuleData(response.data.data[0], host, route);
						moduleApiData = await getArticleSnippetData(moduleRssData, host, route);
						this.SET_MODULES(moduleApiData);
						this.SET_QUIZ(moduleApiData.webmd_module);
						this.SET_STATIC_PUBLIC_PATH(staticPublicPath);
						this.SET_SITEFRONTS();
						this.FRIENDLY_URL(moduleApiData);

						// eslint-disable-next-line no-param-reassign
						rootState.pagedata = moduleApiData.pagedata;

						// Get newsletter mapping from reg service
						rootState.pagedata.newsletterMapping = await getNewsletterMapping(rootState.pagedata, host);

						// Triggering to fetch Asset Relation for Blogs pages only
						const pageCenterPrefix = _get(rootState, 'pagedata.omniture.center_prefix', '');
						if (pageCenterPrefix === 'blogs') {
							await setAssetRelationsUrls(host, moduleApiData.pagedata, this);
						}

						// eslint-disable-next-line no-param-reassign
						rootState.pagedata.headHTML = '';
						const imageServerUrl = rootState?.pagedata?.omniture?.image_server_url;
						const imageLinkTag = utils.preloadFirstSlideImage(moduleApiData.webmd_module, imageServerUrl);
						if (imageLinkTag) {
							rootState.pagedata.headHTML += imageLinkTag;
						}
						// eslint-disable-next-line no-param-reassign,camelcase
						rootState.pagedata.disable_omniture_load = false;
						if (route.query) {
							// eslint-disable-next-line no-param-reassign
							rootState.pagedata.query = route.query;
							if (route.query.tex) {
								// eslint-disable-next-line no-param-reassign
								rootState.pagedata.ad.targets.tex = utils.addTexValue(rootState.pagedata.ad.targets.tex, route.query.tex);
							}
							if (route.query.prop16) {
								// eslint-disable-next-line camelcase
								const context = { 'wb.test': route.query.prop16 };
								// eslint-disable-next-line camelcase,no-param-reassign
								rootState.pagedata.omniture.s_test = rootState.pagedata.omniture.s_test ? `${rootState.pagedata.omniture.s_test}_${context['wb.test']}` : context['wb.test'];

								if (rootState.pagedata.omniture.context) {
									// eslint-disable-next-line camelcase,max-len
									rootState.pagedata.omniture.context['wb.test'] = rootState.pagedata.omniture.context['wb.test'] ? `${rootState.pagedata.omniture.context['wb.test']}_${context['wb.test']}` : context['wb.test'];
								} else {
									// eslint-disable-next-line camelcase
									rootState.pagedata.omniture.context = context;
								}
							}
							if (route.query.prop29) {
								// eslint-disable-next-line camelcase
								const context = { s_sponsor_program: route.query.prop29 };
								// eslint-disable-next-line camelcase,no-param-reassign
								rootState.pagedata.omniture.s_sponsor_program = context.s_sponsor_program;

								if (rootState.pagedata.omniture.context) {
									// eslint-disable-next-line camelcase,max-len
									rootState.pagedata.omniture.context.s_sponsor_program = context.s_sponsor_program;
								} else {
									// eslint-disable-next-line camelcase
									rootState.pagedata.omniture.context = context;
								}
							}

							// CONSPCE-12525 Video AB Test
							if (route.query.videoState) {
								rootState.pagedata.videoState = route.query.videoState;
							}
						}
					} else {
						this.RESET_STATE();
						// eslint-disable-next-line no-console
						console.log('NO DATA FOUND', response.config);
						// eslint-disable-next-line no-param-reassign,camelcase
						rootState.pagedata = {};
					}
				} else {
					this.RESET_STATE();
					// eslint-disable-next-line no-console
					console.log('CANNOT FIND data.data[0]', response.config);
				}
				return this;
			})
			.catch((err) => {
				this.RESET_STATE();
				// eslint-disable-next-line no-console
				console.log(err);
				return this;
			});
	},

	/**
	 * This is called by page-common mixin to updates rootState
	 * Used to update ad targets values like: tugs and pugs which is based on geolocation
	 */
	updatePagedata(data) {
		const rootState = useMainStore();
		// eslint-disable-next-line no-param-reassign
		rootState.pagedata = data;
	},

	addToPageData(data) {
		const rootState = useMainStore();
		// eslint-disable-next-line guard-for-in,no-restricted-syntax
		for (const key in data) {
			rootState.pagedata[key] = data[key];
		}
	},

	updateRootClasses(classList) {
		const rootState = useMainStore();
		if (!rootState.pagedata.rootClasses) {
			rootState.pagedata.rootClasses = new Set();
		}

		rootState.pagedata.rootClasses = new Set([...Array.from(rootState.pagedata.rootClasses), ...classList]);
	},

	/**
	 * This is called by components to preload image and font
	 * Used to add new preload images and fonts from components / cap page
	 * For type images pass url as [{url,[min, max, device]}]
	 * min:minimum width of screen (optional)
	 * max:maximum width of screen (optional)
	 * device: (desktop, tablet, mobile) (optional)
	 */
	appendPreLoadData({ url, type }) {
		const rootState = useMainStore();
		// eslint-disable-next-line no-param-reassign
		if (type === 'image') {
			rootState.pagedata.headHTML += `<link rel="preload" fetchpriority="high" as="image" href="${url}">`;
		}
		if (type === 'font') {
			rootState.pagedata.headHTML += `<link rel="preload" href="${this.staticPublicPath}fonts/${url}" as="font" type="font/woff2" crossOrigin="anonymous">`;
		}
		if (type === 'images' && typeof (url) === 'object') {
			rootState.pagedata.headHTML += utils.getPreloadedImg(url);
		}
	},

	/* This is called to add an alternate link with hreflang tag for SEO from language-toggle-module */
	appendSeoAlternateTag: ({ lang, url }) => {
		const rootState = useMainStore();
		rootState.pagedata.headHTML += `<link rel="alternate" hreflang="${lang}" href="${url}" />`;
	},

	/**
	 * This is called by components to updating page data values like
	 * Used to update omniture, ad target values like: s_assetname, s_pagename, hcent
	 */
	setPageDataByKey({ key, data }) {
		const rootState = useMainStore();
		// eslint-disable-next-line no-param-reassign
		if (key && data) {
			_set(rootState.pagedata, key, _extend(_get(rootState.pagedata, key, {}), data));
		}
	},

	/**
	 * @param state
	 * @param data
	 * @constructor
	 * TODO: Remove this logic from here when everyone starts using channelId as default
	 * Transforms old data structure of webmd_module to object.
	 */
	// eslint-disable-next-line no-shadow
	LOCAL_TRANSFORM_MODULES(data) {
		// reset modules before loading new ones of the new page hit
		// eslint-disable-next-line no-param-reassign
		this.modules = {};
		if (data
			&& data.wbmd_asset
			&& data.wbmd_asset.content_section
			&& data.wbmd_asset.content_section.webmd_page
			&& data.wbmd_asset.content_section.webmd_page.page_data
			&& data.wbmd_asset.content_section.webmd_page.page_data.webmd_module
			&& _isArray(data.wbmd_asset.content_section.webmd_page.page_data.webmd_module)) {
			_forEach(data.wbmd_asset.content_section.webmd_page.page_data.webmd_module, (module) => {
				if (module.module_data && module.module_data.module_chronic_id && _isString(module.module_data.module_chronic_id)) {
					// eslint-disable-next-line no-param-reassign
					this.modules[module.module_data.module_chronic_id] = module;
				}
			});
		} else if (data
			&& data.wbmd_asset
			&& data.wbmd_asset.content_section
			&& data.wbmd_asset.content_section.webmd_page
			&& data.wbmd_asset.content_section.webmd_page.page_data
			&& data.wbmd_asset.content_section.webmd_page.page_data.webmd_module) {
			// eslint-disable-next-line no-param-reassign
			this.modules = clean(data.wbmd_asset.content_section.webmd_page.page_data.webmd_module);
		}
	},

	/**
	 * @param state
	 * @param data
	 * @constructor
	 * Saves new data structure into state.modules property
	 */
	// eslint-disable-next-line no-shadow
	SET_MODULES(data) {
		// eslint-disable-next-line no-param-reassign
		this.modules = {};
		if (data && data.webmd_module) {
			// eslint-disable-next-line
			this.modules = getArticle(clean(data.webmd_module));

			// this.modules = getArticle(clean(data.webmd_module));
			if (this.isInteractivePage === null) {
				this.isInteractivePage = setInteractiveFlag(clean(data.webmd_module));
			}
			_forEach(blackListedModules, (chronicId) => delete this.modules[chronicId]);
		}
	},
	SET_QUIZ(data) {
		const quiz = useQuizStore();
		const moduleKeys = Object.keys(data);
		moduleKeys.pop();
		moduleKeys.forEach((key) => {
			if (data[key].module_settings && data[key].module_settings.title && (data[key].module_settings.title === 'FED-RMQ' || data[key].module_settings.title === 'dyn-rmq')) {
				quiz.addQuizState(data[key].module_settings.metadata_section.i_chronicle_id);
			}
		});
	},

	/**
	 * @param state
	 * @param data
	 * @constructor
	 * Saves new data into state.staticPublicPath property
	 */
	// eslint-disable-next-line no-shadow
	SET_STATIC_PUBLIC_PATH(data) {
		// eslint-disable-next-line no-param-reassign
		this.staticPublicPath = '';
		if (data) {
			// eslint-disable-next-line
			this.staticPublicPath = data;
		}
	},
	// eslint-disable-next-line no-shadow
	SET_SITEFRONTS() {
		this.siteFronts = {};

		const mode = parseMode(_find(this.modules, ['module_settings.wbmd_pb_dyn_module_category.wbmd_storage_val', 'site_fronts_style_config']));
		const styleConfig = parseStyleConfig(_find(this.modules, ['module_settings.wbmd_pb_dyn_module_category.wbmd_storage_val', 'site_fronts_style_config']));
		const navConfig = parseNavConfig(_find(this.modules, ['module_settings.wbmd_pb_dyn_module_category.wbmd_storage_val', 'site_fronts_nav_config']));

		if (styleConfig || navConfig) {
			this.siteFronts.mode = mode;
			this.siteFronts.styleConfig = styleConfig;
			this.siteFronts.navConfig = navConfig;

			delete this.modules[_findKey(this.modules, ['module_settings.wbmd_pb_dyn_module_category.wbmd_storage_val', 'site_fronts_style_config'])];
			delete this.modules[_findKey(this.modules, ['module_settings.wbmd_pb_dyn_module_category.wbmd_storage_val', 'site_fronts_nav_config'])];
		} else {
			this.siteFronts = false;
		}
	},

	// eslint-disable-next-line no-shadow
	SET_RENDERED(key) {
		if (_has(this.modules, key) && typeof window === 'undefined' && process.env.NODE_ENV === 'production') {
			// eslint-disable-next-line no-param-reassign
			_set(this.modules, key, 'RENDERED');
		}
	},

	/**
	 * Resetting the state to nothing when there's no SOLR DATA
	 * @param state
	 * @param data
	 * @constructor
	 */
	// eslint-disable-next-line no-shadow
	RESET_STATE(data) {
		// eslint-disable-next-line no-param-reassign
		this.modules = {};
		// eslint-disable-next-line no-param-reassign
		this.friendlyURLData = {};
		// eslint-disable-next-line no-param-reassign
		this.staticPublicPath = '';
	},

	/**
	 * Mutation to add custom properties to store for any components
	 * @param state
	 * @param data in {key: Object, value}
	 * @constructor
	 */
	// eslint-disable-next-line no-shadow
	UPDATE_STATE(data) {
		if (data.key && data.value) {
			// eslint-disable-next-line no-param-reassign
			this.modules[data.key] = data.value;
		}
	},

	/**
	 * @param state
	 * @param data
	 * @constructor
	 * Changes state.modules property
	 */
	// eslint-disable-next-line no-shadow
	FRIENDLY_URL(data) {
		if (_has(data, 'wbmd_asset.friendlyurls')) {
			// eslint-disable-next-line no-param-reassign
			this.friendlyURLData = {};
			// eslint-disable-next-line no-param-reassign
			this.friendlyURLData = data.wbmd_asset.friendlyurls;
		} else if (_has(data, 'friendlyurls')) {
			// eslint-disable-next-line no-param-reassign
			this.friendlyURLData = {};
			// eslint-disable-next-line no-param-reassign
			this.friendlyURLData = data.friendlyurls;
		}
	},
};

const getters = {
	// eslint-disable-next-line no-shadow
	allModules: (state) => state.modules,
	// eslint-disable-next-line
	getModules: (state) => (chronicleID) => {
		return state.modules[chronicleID];
	},
};

// eslint-disable-next-line import/prefer-default-export
export const useCmsStore = defineStore({
	id: 'cms',
	state: () => ({
		friendlyURLData: {},
		siteFronts: {},
		modules: {},
		staticPublicPath: '',
		isInteractivePage: null,
	}),
	getters,
	actions,
});
